import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

const Dashboard = () => import('@/views/Dashboard')
const Login = () => import('@/views/Login')
const Page404 = () => import('@/views/Page404')

const Clients = () => import('@/views/clients/Clients.vue')
const Reserves = () => import('@/views/reserves/Reserves.vue')
const SMSLogs = () => import('@/views/SMSLogs.vue')

Vue.use(Router)

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'clients',
          name: 'Clients',
          component: Clients
        },
        {
          path: 'reserves',
          name: 'Reserves',
          component: Reserves
        },
        {
          path: 'sms-logs',
          name: 'SMS Logs',
          component: SMSLogs
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }, {
      // not found handler
      path: '*',
      component: Page404
    }
  ]
})
